import ListAgroExporters from "@/views/customer/reporting/container/ListAgroExporters.vue";
import ListProcesses from "@/views/customer/reporting/container/ListProcesses.vue";
import ListContainers from "@/views/customer/reporting/container/ListContainers.vue";
import ListReports from "@/views/customer/reporting/container/ListReports.vue";
import ShowTemplateMainRep from "@/views/customer/reporting/container/ShowTemplateMainRep.vue";
import ShowCustomerReport from "@/views/customer/reporting/container/ShowCustomerReport.vue";

import { routerUtilities } from "@/components/views/mixins/module_routes.js";
const [META, routeName] = routerUtilities({
  entity: "customer",
  role: "reporting",
  permission: "container",
});

export default [
  {
    path: "/customer/:customer_id/reporting/container/agro_exporters",
    name: routeName("list_agro_exporters"),
    component: ListAgroExporters,
    props: true,
    meta: META
  },
  {
    path: "/customer/:customer_id/reporting/container/:agro_exporter_id/processes",
    name: routeName("list_processes"),
    component: ListProcesses,
    props: true,
    meta: META
  },
  {
    path: "/customer/:customer_id/reporting/container/:agro_exporter_id/containers/:agro_exporter_process_id",
    name: routeName("list_containers"),
    component: ListContainers,
    props: true,
    meta: META
  },
  {
    path: "/customer/:customer_id/reporting/container/:agro_exporter_id/reports/:agro_exporter_process_id/:container_id",
    name: routeName("list_reports"),
    component: ListReports,
    props: true,
    meta: META
  },
  {
    path: "/customer/:customer_id/reporting/container/:agro_exporter_id/template_main_rep/:agro_exporter_process_id/:container_id/:quality_template_main_rep_id",
    name: routeName("show_template_main_rep"),
    component: ShowTemplateMainRep,
    props: true,
    meta: META
  },
  {
    path: "/customer/:customer_id/reporting/container/:agro_exporter_id/customer_report/:agro_exporter_process_id/:container_id/:customer_report_id",
    name: routeName("show_customer_report"),
    component: ShowCustomerReport,
    props: true,
    meta: META
  }
];
